import { Box } from '@material-ui/core';
import { OnboardingDetailsRole } from '@nemuru-eng/js-api-client';

import { BorrowerOnboardingDetailsDto } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/types/BorrowerOnboardingDetailsDto';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface ParticipantCardProps {
  borrowerOnboardingDetails: BorrowerOnboardingDetailsDto;
  setSelectedRole: (role: OnboardingDetailsRole | undefined) => void;
  onDeleteBorrowerOnboardingDetails: (role: OnboardingDetailsRole) => void;
}

export const ParticipantCard = ({
  borrowerOnboardingDetails,
  setSelectedRole,
  onDeleteBorrowerOnboardingDetails,
}: ParticipantCardProps) => {
  const { palette, customBorderRadius } = useCustomTheme();
  const { getTextIdTranslation: t } = useTranslation();

  const role = borrowerOnboardingDetails.role;

  const ParticipantRoleChip = () => (
    <Box
      display="flex"
      alignItems="center"
      p="2px 8px"
      border={`1px solid ${palette.grey[200]}`}
      borderRadius={customBorderRadius.chip}
      height="fit-content"
    >
      <Font variant="caption" color="title">
        <strong>{t(role)}</strong>
      </Font>
    </Box>
  );

  return (
    <CustomPaper fill="paper">
      <FlexColumn width="100%">
        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} gridGap={8}>
          <Font variant="body2" color="title">
            <strong>{`${borrowerOnboardingDetails.userDetails.documentId.name.first} ${borrowerOnboardingDetails.userDetails.documentId.name.last}`}</strong>
          </Font>
          <ParticipantRoleChip />
        </Box>
        <Box display={'flex'} flexDirection={'column'} gridGap={6}>
          <Font variant="caption" color="textSecondary">
            {borrowerOnboardingDetails.email}
          </Font>
          <Font variant="caption" color="textSecondary">
            {borrowerOnboardingDetails.phoneNumber}
          </Font>
        </Box>
        <Box display={'flex'} flexDirection={'row'} gridGap={12} justifyContent={'flex-end'} width="100%">
          {role !== OnboardingDetailsRole.BORROWER && (
            <StandardButton
              onClick={() => onDeleteBorrowerOnboardingDetails(role)}
              size="small"
              variant="text"
              endIcon={<Icon size={16}>delete</Icon>}
              style={{ paddingInline: '8px' }}
            >
              {t('DELETE')}
            </StandardButton>
          )}
          <StandardButton
            onClick={() => setSelectedRole(role)}
            size="small"
            variant="outlined"
            endIcon={<Icon size={16}>edit</Icon>}
            style={{ paddingInline: '8px' }}
          >
            {t('EDIT')}
          </StandardButton>
        </Box>
      </FlexColumn>
    </CustomPaper>
  );
};
